function CrossIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.3332 2.54663L17.4532 0.666626L9.99984 8.11996L2.5465 0.666626L0.666504 2.54663L8.11984 9.99996L0.666504 17.4533L2.5465 19.3333L9.99984 11.88L17.4532 19.3333L19.3332 17.4533L11.8798 9.99996L19.3332 2.54663Z" fill="#b1b1b1"/>
    </svg>

  )
}

export default CrossIcon